// Baseurl.js
 
// const baseurl = process.env.BASE_URL || 'http://localhost:5004/api/';   
// const imageUrl = process.env.IMAGE_URL || 'http://localhost:5004/uploads/';

// const baseurl = process.env.BASE_URL || 'https://a2z.evventoz.com/api/';   
// const imageUrl = process.env.IMAGE_URL || 'https://a2z.evventoz.com/uploads/';

const baseurl = process.env.BASE_URL || 'https://backend.topairview.com/api/';
const imageUrl = process.env.IMAGE_URL || 'https://backend.topairview.com/uploads/';  
     

module.exports = { baseurl, imageUrl };
